import axios from 'axios';
import { 
    clearUserLoginStatus,  
    // setUserLoginStatus,
} from '../helpers/authorization';

import { notifyError } from '../helpers/notifications';

const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});

instance.defaults.headers.common['Content-Type'] = 'application/json'
instance.defaults.withCredentials = true

instance.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        const error_response = error && error.response && error.response.data;
        if (!error.response) {
            notifyError({ title: 'Сервер недоступен. Попробуйте ещё раз.' })
            return Promise.reject(error)
        }
        try {            
            const requestUrl = (error.config && error.config.url) || '';
            if (error.response.status === 401 && !String(requestUrl).includes('logout') && !String(requestUrl).includes('get-refresh-token-pair')) {  
                
                await axios({
                    method: 'GET',
                    baseURL: process.env.VUE_APP_BASE_URL,
                    url: 'auth/get-refresh-token-pair',
                    withCredentials: true,
                })
                
                return instance(error.config)
            } else if (error.response.status === 500) {
                notifyError({ title: error_response.error_message, errors: error_response.errors })
                clearUserLoginStatus()
                location.assign('/');
            } else if ([400, 403, 404].includes(error.response.status)) {
                notifyError({ title: error_response.error_message, errors: error_response.errors })
                // return Promise.reject(error)
            } else {
                notifyError({ title: error_response.error_message, errors: error_response.errors })
                clearUserLoginStatus()
                location.assign('/');
                // return Promise.reject(error)
            }
        } catch (innerError) {
            notifyError({
                title: (error_response && error_response.error_message) || 'Сервер недоступен. Попробуйте ещё раз.',
                errors: error_response && error_response.errors,
            })
            return Promise.reject(error)
        }
    }
)

export default instance
